import React from 'react';
import { PropTypes } from 'prop-types';
import Carousel from 'react-material-ui-carousel';
import { Box } from '@mui/material';

const SeekerForYouListings = ({ itemsPerSlide, listingSlides }) => {
  if (listingSlides.length === 0) return null;
  const seed = React.useRef(Math.round(Math.random() * 100000));

  return (
    <Carousel
      navButtonsAlwaysVisible
      cycleNavigation={false}
      animation="slide"
      indicators={false}
      autoPlay={false}
      navButtonsProps={{ style: { zIndex: 1, opacity: 0.5, margin: 1 } }}
    >
      {listingSlides.map((group) => (
        <Box
          key={`carousel_${seed}_${itemsPerSlide}_slide_${group[0].id}`}
          sx={{
            display: 'flex',
            gap: 2,
            justifyContent: 'flex-start',
            paddingLeft: '16px',
            '@media (max-width:1299px)': {
              justifyContent: 'center',
              paddingLeft: '0px',
            },
          }}
        >
          {group.map((listingComponent, idx) => (
            <Box
              // eslint-disable-next-line react/no-array-index-key
              key={`listing_slide_${idx}`}
              sx={{
                width: '330px',
                flex: '0 0 330px',
              }}
            >
              {listingComponent}
            </Box>
          ))}
        </Box>
      ))}
    </Carousel>

  );
};

SeekerForYouListings.defaultProps = {
  listingSlides: [],
};

SeekerForYouListings.propTypes = {
  itemsPerSlide: PropTypes.number.isRequired,
  listingSlides: PropTypes.array,
};

export default SeekerForYouListings;
